var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 172.497,
    viewBox: "0 0 147 172.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_169",
    x: 0,
    y: 25.497,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 60.049,
    height: 60.049,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(-341.5 -2975.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(0 416.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 341.5, 2975)",
    filter: "url(#Rectangle_169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169-2",
    "data-name": "Rectangle 169",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(16.5 39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(378.975 3040.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M108.382,23.5,86.19,37.858,64,23.5V1.306A1.278,1.278,0,0,1,65.248,0h41.829a1.278,1.278,0,0,1,1.305,1.25q0,.028,0,.055Z",
    transform: "translate(-56.165 0)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M7.832,98.39,0,93.169l7.832-7.832Z",
    transform: "translate(0 -74.892)",
    fill: "#f6b445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M434.5,93.168l-7.833,5.222V85.336Z",
    transform: "translate(-374.45 -74.892)",
    fill: "#f6b445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M302.349,154.44l7.832-5.1v36.552a5.254,5.254,0,0,1-1.527,3.694l-8.916-8.916-14.36-14.36-.366-.561Z",
    transform: "translate(-250.132 -131.06)",
    fill: "#fed049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M60.559,298.337l8.916,8.916a5.254,5.254,0,0,1-3.694,1.527H16.174a5.254,5.254,0,0,1-3.694-1.527l8.916-8.916,14.36-14.36.366-.561,4.856,3.172,4.856-3.172.366.561Z",
    transform: "translate(-10.953 -248.731)",
    fill: "#f6b445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M25.169,165.745l-.366.561-14.36,14.36-8.916,8.916A5.254,5.254,0,0,1,0,185.888V149.336Z",
    transform: "translate(-0.001 -131.06)",
    fill: "#fed049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M250.332,0a15.665,15.665,0,1,1-15.665,15.665A15.665,15.665,0,0,1,250.332,0",
    transform: "translate(-205.948 -0.003)",
    fill: "#a58500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M325.219,89.026a1.305,1.305,0,0,1-1.305-1.305V78.41l-1.886,1.258a1.306,1.306,0,0,1-1.449-2.172l3.916-2.611a1.305,1.305,0,0,1,2.03,1.086V87.721a1.305,1.305,0,0,1-1.305,1.305",
    transform: "translate(-280.835 -65.528)",
    fill: "#f1f2f2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadEngagement);
export default __webpack_public_path__ + "static/media/lead-engagement.4e16f9ed2d9d528e05557cf70007beac.svg";
export { ForwardRef as ReactComponent };